import { render, staticRenderFns } from "./RequestReturnTable.vue?vue&type=template&id=87e4e23e&scoped=true"
import script from "./RequestReturnTable.vue?vue&type=script&lang=js"
export * from "./RequestReturnTable.vue?vue&type=script&lang=js"
import style0 from "./RequestReturnTable.vue?vue&type=style&index=0&id=87e4e23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e4e23e",
  null
  
)

export default component.exports